import { createClient } from '@supabase/supabase-js';
import { createAuthStorage } from './authStorage';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;

export const hasSupabaseConfig = Boolean(url && publishableKey);

// O cliente precisa existir para que o React consiga montar a interface mesmo
// quando uma instalação local ainda não recebeu o .env. O fluxo de restauração
// é interrompido de forma explícita nesse caso, evitando uma página branca.
const clientUrl = url ?? 'https://placeholder.supabase.co';
const clientKey = publishableKey ?? 'sb_publishable_missing_configuration';

const storageKey = `sb-${new URL(clientUrl).hostname.split('.')[0]}-auth-token`;
export const authPersistence = createAuthStorage(localStorage, sessionStorage, storageKey);

export const supabase = createClient(clientUrl, clientKey, {
  auth: { persistSession: true, storageKey, storage: authPersistence.storage, autoRefreshToken: true, detectSessionInUrl: true },
});
